export default class KeyVal {
  [value: string]: any;
}

export const getEnumKeys = (enumType: any) => {
  return Object.keys(enumType);
};

export const getEnumValue = (enumType: any, key: string) => {
  return enumType[getEnumKeys(enumType).filter((k) => {
    return key === k;
  }).pop() || ''];
};